$shm_hitalama_benchmarks_catalog $mol_book2_catalog
	menu_title \Бенчмарки
	param \benchmark
	menu_filter_enabled true
	Page* $mol_page
		title <= benchmark_title* \
		body <= benchmark_body* /$mol_view
	Text* $shm_hitalama_textbook_text
		text <= benchmark_text* \
		param \benchmark_part
	Chart_box* $mol_view
		sub /
			<= Chart* $shm_echarts
				option <= benchmark_option* null
